import { memo, ReactNode } from "react";
import { useShallow } from "zustand/react/shallow";

import TableHeadColumnWithActions from "ds/components/Table/Head/Column/WithActions";
import { TableColumnMeta } from "ds/components/Table/types";
import { TableColumnsState } from "ds/components/Table/useTableStore/types";
import { AnalyticsPageOrganization } from "hooks/useAnalytics/pages/organization";

import { FILTERS_ORDER_SETTINGS_KEY, IDP_GROUP_COLUMN_ID, SORT_CONFIG } from "../../constants";
import { useIdpGroupTableStore } from "../useIdpGroupTableStore";

type IdpGroupTableHeadColumnProps = {
  column: TableColumnMeta<IDP_GROUP_COLUMN_ID>;
  children?: ReactNode;
};

const IdpGroupTableHeadColumn = ({ column, children }: IdpGroupTableHeadColumnProps) => {
  const { columnSizes, setColumnSize, columnsOrder } = useIdpGroupTableStore(
    useShallow((state: TableColumnsState<IDP_GROUP_COLUMN_ID>) => ({
      columnSizes: state.columnsSizes,
      setColumnSize: state.setColumnSize,
      columnsOrder: state.columnsOrder,
    }))
  );

  return (
    <TableHeadColumnWithActions<IDP_GROUP_COLUMN_ID>
      column={column}
      stickyLeft={column.id === IDP_GROUP_COLUMN_ID.GROUP_ID}
      stickyRight={column.id === IDP_GROUP_COLUMN_ID.DROPDOWN}
      columnSizes={columnSizes}
      columnsOrder={columnsOrder}
      setColumnSize={setColumnSize}
      sortConfig={SORT_CONFIG}
      analyticsPage={AnalyticsPageOrganization.OrganizationIdpGroupMapping}
      filterOrderSettingsKey={FILTERS_ORDER_SETTINGS_KEY}
    >
      {children}
    </TableHeadColumnWithActions>
  );
};

export default memo(IdpGroupTableHeadColumn);
